import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Switch, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  checked: boolean;
  disabled?: boolean;
  label: string;
  description: string;
  onChange: () => void;
}

export const SwitchField: React.FC<Props> = ({
  checked,
  disabled = false,
  label,
  description,
  onChange,
}) => {
  const theme = useTheme<LensTheme>();
  const sp = theme.tokens.semantic.spacing.desktop.gap;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Switch
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          slotProps={{
            input: {
              sx: {
                width: '100% !important',
                height: '100% !important',
              },
            },
          }}
        />
        <Typography sx={{ fontSize: '16px', fontWeight: 400 }}>
          {label}
        </Typography>
      </Box>
      {description && (
        <Typography
          sx={{ fontSize: '12px', fontWeight: 300, mt: sp['0_5'].value }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
